import React, { useState } from 'react'

import LabeledField from '../Forms/LabeledField'
import NavButtons from './NavButtons'
import FileUploadComponent from '../Forms/DropUpload'

import axios from 'axios'

export default function ShortAnswerQuestion(props) {

  const defaultAnswer = {...props.question.answer}
  const [ answer, setAnswer ] = useState(defaultAnswer)
  const [ errors, setErrors ] = useState({})

  const updateAnswer = (e) => {
    setErrors({})
    const newAnswer = { ...answer }
    newAnswer[e.target.name] = e.target.value
    setAnswer(newAnswer)
  }

  const submit = () => {
    const newErrors = {}
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
    } else {
      return axios.patch('/api/questions/' + props.question.id, {
        answer: answer
      })
    }
  }

  const nextEnabled = () => {
    return answer?.text?.length > 0
  }

  return (
    <div>
      <div className="questionInputs">
        <div className="shortAnswer">
          <textarea
            name="text"
            onChange={updateAnswer}
          >
            { answer['text'] }
          </textarea>
        </div>
        <FileUploadComponent question={props.question.id} />
        <NavButtons
          submit={submit}
          question={props.question}
          goPrev={props.goPrev}
          goNext={props.goNext}
          nextEnabled={nextEnabled}
        />
      </div>
    </div>
  )
}
